import { AppShell, Button, Group, Text } from '@mantine/core';
import { IconUser } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';
import css from '../../components/css/Shell.module.css';

export function UnauthNavbar() {
	const navigate = useNavigate();

	return (
		<>
			<AppShell.Header>
				<Group h="100%" px={'lg'} justify={'space-between'}>
					<Group>
						<Text size={'xl'} fw={500}>
							MedEpos
						</Text>
					</Group>
					<Group>
						<Button
							variant={'light'}
							className={css.accountButton}
							onClick={() => navigate('/login')}
							rightSection={<IconUser size="1rem" />}
						>
							Login
						</Button>
					</Group>
				</Group>
			</AppShell.Header>
			<AppShell.Navbar />
		</>
	);
}
